import { render, staticRenderFns } from "./InventarioSimForm.vue?vue&type=template&id=3b654f02&"
import script from "./InventarioSimForm.vue?vue&type=script&lang=ts&"
export * from "./InventarioSimForm.vue?vue&type=script&lang=ts&"
import style0 from "./InventarioSimForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports